import * as Reports from './reports/reports.service';
import * as Offers from './offers/offers.service';
import * as Configurations from './configurations/configurations.service';
import * as Loads from './loads/loads.service';
import * as Pool from './pool/pool.service';

export default {
    Reports,
    Offers,
    Configurations,
    Loads,
    Pool,
};
